import * as React from "react";
import * as ReactDOM from "react-dom";

import Discussion from "./components/Discussion";

window['discussion'] = (element: HTMLElement) => {

    ReactDOM.render(
        <Discussion
            id={parseInt(element.getAttribute("data-id"))}
            project={
                element.hasAttribute("data-project") ?
                    parseInt(element.getAttribute("data-project")) : null
            }
            total={parseInt(element.getAttribute("data-total"))}
            locale={element.getAttribute("data-locale")}
            login={element.getAttribute("data-login")}
            verify={element.getAttribute("data-verify")}
            fullwidth={element.getAttribute("data-fullwidth") == "1"}
            premium={element.getAttribute("data-premium") == "1"}
            open={element.getAttribute("data-open") == "1"}
            badges={
                element.hasAttribute("data-badges") ?
                    element.getAttribute("data-badges") == "1" : true
            }
        />,
        element
    );

};
